module.exports = __webpack_public_path__ + "img/puzzle.a5797066.svg";